// Navigation constants
export const ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  SEARCH: '/search',
  CALCULATORS: '/calculators',
  HOME_LOAN: '/calculators/home-loan',
  AUTO_LOAN: '/calculators/auto-loan',
  PERSONAL_LOAN: '/calculators/personal-loan',
  STUDENT_LOAN: '/calculators/student-loan',
  MORTGAGE: '/calculators/mortgage',
  LOAN_COMPARISON: '/calculators/loan-comparison',
  PREPAYMENT_IMPACT: '/calculators/prepayment-impact',
  LOAN_AFFORDABILITY: '/calculators/loan-affordability',
  PROFILE: '/profile',
  HISTORY: '/history',
  CHAT: '/chat',
  AI_RESULTS: '/ai-results',
  SUBSCRIPTION: '/subscription',
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_OF_SERVICE: '/terms-of-service'
} as const;

// Navigation helper functions
export const isAuthRoute = (pathname: string): boolean => {
  return false; // No auth routes anymore
};

export const isDashboardRoute = (pathname: string): boolean => {
  const dashboardRoutes: string[] = [
    ROUTES.DASHBOARD,
    ROUTES.SEARCH,
    ROUTES.PROFILE,
    ROUTES.HISTORY,
    ROUTES.CHAT,
    ROUTES.AI_RESULTS,
    ROUTES.HOME_LOAN,
    ROUTES.AUTO_LOAN,
    ROUTES.PERSONAL_LOAN,
    ROUTES.STUDENT_LOAN,
    ROUTES.MORTGAGE,
    ROUTES.LOAN_COMPARISON,
    ROUTES.PREPAYMENT_IMPACT,
    ROUTES.LOAN_AFFORDABILITY
  ];
  
  return dashboardRoutes.includes(pathname as any) || pathname.startsWith('/calculators') || pathname.startsWith('/admin');
};

export const isStandaloneRoute = (pathname: string): boolean => {
  return pathname === ROUTES.PRIVACY_POLICY || 
         pathname === ROUTES.TERMS_OF_SERVICE || 
         pathname === ROUTES.SUBSCRIPTION || 
         pathname === '/pricing' || 
         pathname === '/about' || 
         pathname === '/contact' || 
         pathname === '/editorial-policy' || 
         pathname === '/disclaimer' || 
         pathname === '/author/maulik-kumbhani' ||
         pathname.startsWith('/cookie-policy');
};

export const shouldShowHeaderFooter = (pathname: string): boolean => {
  return !isAuthRoute(pathname) && !isDashboardRoute(pathname) && !isStandaloneRoute(pathname);
};

// URL helpers
export const buildUrl = (route: string, params: Record<string, string> = {}): string => {
  let url = route;
  Object.keys(params).forEach(key => {
    url = url.replace(`:${key}`, params[key]);
  });
  return url;
};